/**
 * Безопасное логирование ошибок для предотвращения проблем с blob responseType
 * 
 * React Native LogBox пытается читать responseText из XMLHttpRequest,
 * что вызывает ошибку если responseType = 'blob'
 */

export const safeLogError = (message: string, error: unknown): void => {
  if (error instanceof Error) {
    console.error(message, error.message);
  } else if (typeof error === 'string') {
    console.error(message, error);
  } else if (error && typeof error === 'object') {
    // Проверяем, является ли это axios-ошибкой с blob response
    const axiosError = error as any;
    if (axiosError.config?.responseType === 'blob' || axiosError.response?.config?.responseType === 'blob') {
      const safeError = {
        message: axiosError.message || 'Unknown error',
        status: axiosError.response?.status,
        statusText: axiosError.response?.statusText,
        url: axiosError.config?.url,
      };
      console.error(message, JSON.stringify(safeError));
    } else {
      // Безопасно извлекаем только примитивные свойства
      try {
        const safeError = {
          message: axiosError.message,
          status: axiosError.response?.status,
          data: axiosError.response?.data,
        };
        console.error(message, JSON.stringify(safeError, null, 2));
      } catch {
        console.error(message, 'Error object could not be serialized');
      }
    }
  } else {
    console.error(message, 'Unknown error type');
  }
};

export const safeLogWarn = (message: string, data?: unknown): void => {
  if (data === undefined) {
    console.warn(message);
  } else if (typeof data === 'string' || typeof data === 'number' || typeof data === 'boolean') {
    console.warn(message, data);
  } else {
    try {
      console.warn(message, JSON.stringify(data, null, 2));
    } catch {
      console.warn(message, 'Data could not be serialized');
    }
  }
};
